import React from 'react';

import svg from './assets/icons-24-close.svg';
import type { IconProps } from './SvgIcon';
import { SvgIcon } from './SvgIcon';

export const IconClose = (props: IconProps) => <SvgIcon {...props} src={svg} testId="icon-close" />;
